angular.module('app').directive('adminDatepicker', function() {
    return {
        restrict: 'A',
        priority: -1,
        require: '?^mdInputContainer',
        compile: function(element) {
            var calendarIcon = element[0].querySelector('.md-datepicker-calendar-icon');
            var calendarPane = element[0].querySelector('.md-datepicker-calendar-pane');
            var expandTriangle = element[0].querySelector('.md-datepicker-expand-triangle');

            if (calendarIcon) {
                angular.element(calendarIcon)
                    .removeAttr('md-svg-src')
                    .attr('md-svg-icon', 'date-picker');
            }

            if (calendarPane) {
                angular.element(calendarPane).addClass('admin-datepicker-calendar-pane');
            }

            if (expandTriangle) {
                var arrowIcon = document.createElement('md-icon');

                arrowIcon.className = 'admin-datepicker-triangle-icon';
                arrowIcon.setAttribute('md-svg-icon', 'down-arrow');
                arrowIcon.setAttribute('aria-hidden', 'true');
                expandTriangle.parentNode.replaceChild(arrowIcon, expandTriangle);
            }

            return function(scope, element, attrs, mdInputContainer) {
                if (mdInputContainer) {
                    mdInputContainer.element.addClass('admin-datepicker-field');
                }
            };
        }
    };
});
